import { render, staticRenderFns } from "./ResourceScholarships.vue?vue&type=template&id=565f9186"
import script from "./ResourceScholarships.vue?vue&type=script&lang=js"
export * from "./ResourceScholarships.vue?vue&type=script&lang=js"
import style0 from "./ResourceScholarships.vue?vue&type=style&index=0&id=565f9186&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports